/* eslint react/forbid-prop-types: 0 */
/* global globals, translations */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import {
  PaymentOptions,
  SubscriptionSms,
  HighlightSms,
  SubscriptionPaymentSummary,
  HighlightPaymentSummary,
} from '../../components/payments';

const PaymentOptionsContainer = (props) => {
  const {
    active,
    data,
    type,
    onCheckout,
  } = props;
  //
  if (!active || !data) {
    return null;
  }

  //
  let containerClass = 'paymentOption-container';
  if (type === 'highlight') {
    containerClass += ' paymentOption-container--compact';
  }
  if (data.type === 'sms') {
    containerClass += ' paymentOption-container--sms';
  }

  //
  let recurringMessage = 'txt: Abonements atjaunosies automātiski.';
  if (data.campaign) {
    recurringMessage = 'txt: Abonements atjaunosies automātiski par standarta cenu.';
  }

  let pinURL = '/payments/t2r_send_pin';
  if (data.sms_adapter === 'esteria') {
    pinURL = '/payments/esteria_send_pin';
  }

  //
  const mainTitle = () => {
    const title = data.type === 'sms' ? 'txt: SMS apmaksa' : 'txt: Izvēlies maksāšanas veidu';
    return get(translations, title, title);
  };

  //
  const smsOption = () => {
    const smsSupport = {
      lv: 'txt: Pakalpojums pieejams LMT, TELE2 un BITE klientiem.',
      lt: 'txt: Pakalpojums pieejams BITE, OMNITEL un TELE2 klientiem.',
      ee: 'txt: Pakalpojums pieejams TELE2, EMT un Elisa klientiem.',
    };

    return type === 'highlight' ? (
      <HighlightSms
        smsSupport={smsSupport[get(globals, 'region', '')]}
        phoneCode={data.phoneCode}
        smsCode={data.smsCode}
        amountToPay={data.amountToPay}
      />
    ) : (
      <SubscriptionSms
        recurringMessage={recurringMessage}
        smsSupport={smsSupport[get(globals, 'region', '')]}
        pinURL={pinURL}
      />
    );
  };

  //
  return (
    <div
      className={containerClass}
      data-payment-type={type}
      data-payment-length={active}
      data-payment-amount={data.amountToPay.toFixed(2)}
      data-payment-currency={get(globals, 'currency', '')}
    >
      {(type === 'subscription' || type === 'subscription_other') && (
        <div className="paymentOption-title">{mainTitle()}</div>
      )}
      <div className={`paymentOption${type === 'highlight' ? ' paymentOption--compact' : ''}`}>
        <div className="paymentOption-cell">
          {type === 'highlight' && (
            <HighlightPaymentSummary data={data} />
          )}
          {(type === 'subscription' || type === 'subscription_other') && (
            <SubscriptionPaymentSummary data={data} />
          )}
          <div className={`paymentOption-separator${type === 'highlight' ? ' paymentOption-separator--long' : ''}`} />
          {data.type === 'sms' ? smsOption() : (
            <PaymentOptions
              recurringMessage={recurringMessage}
              onCheckout={onCheckout}
            />
          )}
        </div>
      </div>
    </div>
  );
};

PaymentOptionsContainer.propTypes = {
  type: PropTypes.string.isRequired,
  active: PropTypes.string,
  data: PropTypes.instanceOf(Object),
  onCheckout: PropTypes.func.isRequired,
};
PaymentOptionsContainer.defaultProps = {
  active: null,
  data: null,
};

export default PaymentOptionsContainer;
